import { render, staticRenderFns } from "./anomalyList.vue?vue&type=template&id=7a87e457&scoped=true"
import script from "./anomalyList.vue?vue&type=script&lang=js"
export * from "./anomalyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a87e457",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a87e457')) {
      api.createRecord('7a87e457', component.options)
    } else {
      api.reload('7a87e457', component.options)
    }
    module.hot.accept("./anomalyList.vue?vue&type=template&id=7a87e457&scoped=true", function () {
      api.rerender('7a87e457', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/risk/anomalyList.vue"
export default component.exports